import { ACTION_TYPES } from 'lib/Constants';

const {
  LOAD_ASSOCIATIONS_LIST,
  ADD_ASSOCIATIONS,
  LOAD_ASSOCIATIONS_DETAIL,
  CLEAR_ASSOCIATIONS_DETAIL
} = ACTION_TYPES;


export default {
  LOAD_ASSOCIATIONS_LIST: LOAD_ASSOCIATIONS_LIST,
  ADD_ASSOCIATIONS:ADD_ASSOCIATIONS,
  LOAD_ASSOCIATIONS_DETAIL: LOAD_ASSOCIATIONS_DETAIL,
  CLEAR_ASSOCIATIONS_DETAIL:CLEAR_ASSOCIATIONS_DETAIL
}
